import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTakeoffs = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M17.5822 0.997896C18.3633 0.216848 19.6296 0.216847 20.4107 0.997896L26.9965 7.58371C27.7775 8.36476 27.7775 9.63109 26.9965 10.4121L10.4148 26.9938C9.63378 27.7748 8.36745 27.7748 7.5864 26.9938L1.00058 20.408C0.219533 19.6269 0.219533 18.3606 1.00058 17.5795L17.5822 0.997896ZM25.5823 8.99793L18.9965 2.41211L15.9115 5.49706L19.2072 8.79276C19.5977 9.18328 19.5977 9.81645 19.2072 10.207C18.8167 10.5975 18.1835 10.5975 17.793 10.207L14.4973 6.91127L11.4115 9.99706L14.7072 13.2928C15.0977 13.6833 15.0977 14.3164 14.7072 14.707C14.3167 15.0975 13.6835 15.0975 13.293 14.707L9.99729 11.4113L6.9115 14.4971L10.2072 17.7928C10.5977 18.1833 10.5977 18.8164 10.2072 19.207C9.81668 19.5975 9.18351 19.5975 8.79299 19.207L5.49729 15.9113L2.41479 18.9938L9.00061 25.5796L25.5823 8.99793Z",
		fill: "currentColor"
	})
});
export default SvgTakeoffs;
